import React from 'react';

const ShimmerBox = ({ className }) => (
  <div className={`bg-gray-200 rounded ${className}`} />
);

const BarChartSkeleton = () => {
  return (
    <div className="relative bg-white p-4 lg:p-6 rounded-lg border border-gray-100 shadow-sm overflow-hidden">
      <div className="animate-pulse">
        <ShimmerBox className="h-6 w-1/3 mb-6" />
        <div className="flex items-end justify-between h-48 mb-6">
          {[...Array(7)].map((_, i) => (
            <ShimmerBox
              key={i}
              className={`w-8 rounded-t ${['h-20', 'h-32', 'h-48', 'h-28', 'h-40', 'h-16', 'h-36'][i]}`}
            />
          ))}
        </div>
      </div>
      <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/80 to-transparent" />
    </div>
  );
};

export default BarChartSkeleton;